import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { UiHelper } from '../helpers/UiHelper';
import { AppHelper } from '../../helpers/AppHelper';
import { Tooltip } from '@material-ui/core';
import { AppTheme } from '../../styles/AppTheme';

export class UniBox extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isUniboxBtnEnabled: this.props.isUniboxBtnEnabled || false
    }
  }

  onUniboxBtnClick() {
    this.setState(prevState => ({...prevState, isUniboxBtnEnabled: !prevState.isUniboxBtnEnabled}), ()=>{
      this.props.onUniboxBtnClick(this.state.isUniboxBtnEnabled)
    })
  }

  render() {
    if(!this.props.orgId || !this.props.onUniboxBtnClick || !AppHelper.isCRMUniboxEnabled(this.props.orgId)) {
      return null
    }

    return( <Tooltip title={'Toggle Unibox'} classes={{ popper: css(Styles.tooltip) }}>
      <div className={css(Styles.buttonFiltersInnerContainer)}>
        {UiHelper.buttonWithBadge({
          buttonStyle: this.state.isUniboxBtnEnabled ? Styles.filtersButtonSelected : Styles.filtersButton,
          buttonTextStyle: Styles.buttonText,
          iconContainerStyle: Styles.iconContainerStyle,
          iconStyle: Styles.iconStyle,
          onClickHandler: this.onUniboxBtnClick.bind(this),
          icon: 'mail',
          badgeContent: this.props.uniBoxCount
        })}
      </div>
    </Tooltip>)
  }
}


const Styles = StyleSheet.create({
  tooltip: {
    zIndex: 9999999999
  },
  buttonFiltersInnerContainer: {
    paddingLeft: 0,
  },
  filtersButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: AppTheme.primaryColor,
    boxShadow: 'none',
    border: '1px solid #E5E5E5',
    borderRadius: 16,
    backgroundColor: AppTheme.secondaryBg,
    fontSize: 16,
    fontWeight: 500,
    minWidth: 'unset',
    lineHeight: 'unset',
    height: 54,
    width: 54,
    textTransform: 'unset',
    '@media (max-width: 1024px)': {
      padding: 0,
      width: 50
    }
  },
  filtersButtonSelected: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: AppTheme.primaryColor,
    boxShadow: 'none',
    border: '2px solid #0246E5',
    borderRadius: 16,
    backgroundColor: 'unset',
    fontSize: 16,
    fontWeight: 500,
    minWidth: 'unset',
    lineHeight: 'unset',
    height: 54,
    width: 54,
    textTransform: 'unset',
    '@media (max-width: 1024px)': {
      padding: 0,
      width: 50
    }
  },
  buttonText: {
    color: AppTheme.primaryColor
  },
  iconContainerStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 5,
    color: AppTheme.primaryColor,
    cursor: 'pointer',
    margin: 0,
    border: 'unset',
  },
  iconStyle: {
    fontSize: 28
  },

})
